import { render } from "./layoutMain.vue?vue&type=template&id=04ba0e49&scoped=true"
import script from "./layoutMain.vue?vue&type=script&lang=js"
export * from "./layoutMain.vue?vue&type=script&lang=js"

import "./layoutMain.vue?vue&type=style&index=0&id=04ba0e49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ba0e49"]])

export default __exports__